import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { SafeUrlPipe } from '../../utils/safe-url.pipe';
import { ComponentsModule } from '../../components/components.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {NgxMatomoTrackerModule} from 'ngx-matomo-client';


@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    HomeComponent,
    SafeUrlPipe
  ],
    imports: [
        CommonModule,
        RouterModule.forChild([{path: '', component: HomeComponent}]),
        ComponentsModule,
        FontAwesomeModule,
        NgxMatomoTrackerModule,
    ]
})
export class HomeModule {

}
